<template>
  <el-dialog
    title="邀请供销商"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
  >
    <!-- <el-row style="display: flex; align-items: center">
      <el-col :span="2" :offset="0"> 分享链接: </el-col>
      <el-col :span="12" :offset="1">
        <el-input v-model="form.link" disabled></el-input>
      </el-col>
      <el-col :span="2" :offset="0" style="margin-left: 10px">
        <el-button
          type="primary"
          :disabled="disabled"
          v-clipboard:copy="form.link"
          v-clipboard:success="() => $message.success('复制成功')"
          >复制链接</el-button
        >
      </el-col>
    </el-row>
    <el-row style="display: flex; margin-top: 30px">
      <el-col :span="3" :offset="0"> 分享二维码: </el-col>
      <el-col
        :span="12"
        :offset="0"
        style="
          border: 1px solid #1890ff;
          padding: 20px;
          display: flex;
          justify-content: space-evenly; ;
        "
      >
        <div style="background: #f1f4ff; padding: 10px 20px" class="dis-f-c-c">
          <p style="font-size: 14px">长按识别</p>
          <p style="font-size: 16px; font-weight: 700">开展业务合作</p>
        </div>
        <vue-qr ref="Qrcode" :text="form.link" :margin="10" :size="140" />
      </el-col>
      <el-col
        :span="2"
        :offset="0"
        style="
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          margin-left: 10px;
        "
      >
        <el-button :disabled="disabled" type="primary" @click="handleDownloadQrCode"
          >下载图片</el-button
        >
      </el-col>
    </el-row>
    <el-row v-if="disabled" style="margin-top:20px;overflow: hidden;">
      <el-col :offset="3">
        <p style="color: red">注：请先在ERP-分销-供销基础设置，生成服务号，再返回供应链刷新此页打开此弹窗</p>
      </el-col>
    </el-row> -->
    <Invite />
  </el-dialog>
</template>

<script>
import vueQr from "vue-qr";
import { isToExamine, disInviteSupplierUrl } from "@api/supplier";
import Invite from "@/components/invite";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    vueQr,
    Invite,
  },
  data() {
    return {
      form: {
        link: `${window.location.origin}/supplier/management/mine?`,
      },
      companyInfo: {},
      disabled: false,
    };
  },
  mounted() {
    this.handleGetDmsCompanyInfo();
  },
  methods: {
    async handleGetDmsCompanyInfo() {
      try {
        const res = await disInviteSupplierUrl();
        // const { companyId, needAudit, companyName, serviceId } = res.data;

        // if (!serviceId) {
        //   return this.disabled = true
        // }
        // this.disabled = false;
        // this.companyInfo = res.data;
        // let isExamine = needAudit === 0 ? false : true;

        this.form = {
          link: res.data
        };
      } catch (error) {
        console.log("error: ", error);
      }
    },
    handleDownloadQrCode() {
      const imgUrl = this.$refs.Qrcode.$el.src;
      let a = document.createElement("a");
      let event = new MouseEvent("click");
      a.download = "二维码";
      a.href = imgUrl;
      a.dispatchEvent(event);
    },
    // 合作商需要审核
    async handleChangeExamine(needAudit) {
      const res = await isToExamine({
        needAudit: needAudit ? 1 : 0,
      });
      this.handleGetDmsCompanyInfo();
    },
    handleClose() {
      this.$emit("update:dialogVisible", false);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-input__inner {
    background-color: #f5f5f5 !important;
    height: 32px;
  }
  .el-button {
    width: 120px;
    line-height: 20px;
  }
}
</style>